export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (tenantId: string | null) => [...roleKeys.lists(), tenantId] as const,
  permissions: () => [...roleKeys.all, 'permissions'] as const,
};
